<div class="font-poppins">
  <nz-card class="margin-bottom: 16px;" *ngIf="notificationFormVisible">
    <h4 class="m-b-16">{{ formTitle }}</h4>
    <nz-spin nzTip="Please wait..." [nzSpinning]="isLoading">
      <nz-tabset
        class="notification-form-tabs"
        [nzSelectedIndex]="isAnnouncementChannel ? 1 : 0"
        (nzSelectedIndexChange)="onFormTabChange($event)"
      >
        <nz-tab nzTitle="Push Notification" [nzDisabled]="updateMode && isAnnouncementChannel">
          <form nz-form nzLayout="vertical" [formGroup]="notificationForm" class="notification-tab-form">
        <div nz-row nzGutter="16">
          <div nz-col nzSpan="24">
            <nz-form-item>
              <nz-form-label nzRequired>Title</nz-form-label>
              <nz-form-control>
                <input nz-input formControlName="title" placeholder="Notification title" />
                <span class="text-danger" *ngIf="notificationForm.get('title')?.errors?.['required'] && notificationForm.get('title')?.touched">
                  This field is required.
                </span>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div nz-row nzGutter="16">
          <div nz-col nzSpan="24">
            <nz-form-item>
              <nz-form-label nzRequired>Body</nz-form-label>
              <nz-form-control>
                <textarea nz-input formControlName="body" rows="4" placeholder="Notification body"></textarea>
                <span class="text-danger" *ngIf="notificationForm.get('body')?.errors?.['required'] && notificationForm.get('body')?.touched">
                  This field is required.
                </span>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div nz-row nzGutter="16">
          <div nz-col nzSpan="12">
            <nz-form-item>
              <nz-form-label nzRequired>Send Type</nz-form-label>
              <nz-form-control>
                <nz-radio-group formControlName="deliveryType">
                  <label nz-radio nzValue="instant">Instant</label>
                  <label nz-radio nzValue="scheduled">Scheduled</label>
                </nz-radio-group>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzSpan="12">
            <nz-form-item>
              <nz-form-label [nzRequired]="isScheduled">Schedule Date <span class="tz-hint">(US Pacific Time)</span></nz-form-label>
              <nz-form-control>
                <nz-date-picker
                  formControlName="scheduledAt"
                  [nzShowTime]="scheduleTimeOptions"
                  nzFormat="MM/dd/yyyy h:mm a"
                  nzPlaceHolder="Select schedule date and time (US Pacific)"
                  style="width: 100%;"
                  [nzDisabled]="!isScheduled"
                ></nz-date-picker>
                <span class="text-danger" *ngIf="notificationForm.get('scheduledAt')?.errors?.['required'] && notificationForm.get('scheduledAt')?.touched">
                  Schedule date is required for scheduled notifications.
                </span>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div nz-row nzGutter="16">
          <div nz-col nzSpan="12">
            <nz-form-item>
              <nz-form-label>Deep Link Type</nz-form-label>
              <nz-form-control>
                <nz-select formControlName="deepLinkType" nzPlaceHolder="Select link type">
                  <nz-option [nzValue]="0" nzLabel="None"></nz-option>
                  <nz-option [nzValue]="1" nzLabel="Resource"></nz-option>
                  <nz-option [nzValue]="2" nzLabel="Course"></nz-option>
                  <nz-option [nzValue]="3" nzLabel="Quiz"></nz-option>
                  <nz-option [nzValue]="4" nzLabel="Newsletter"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col nzSpan="12">
            <nz-form-item>
              <nz-form-label [nzRequired]="notificationForm.get('deepLinkType')?.value !== 0">Linked Item</nz-form-label>
              <nz-form-control>
                <nz-select
                  formControlName="deepLinkId"
                  nzPlaceHolder="Select from latest 10 items"
                  [nzDisabled]="notificationForm.get('deepLinkType')?.value === 0"
                  [nzLoading]="linkItemsLoading"
                  nzShowSearch
                >
                  <nz-option *ngFor="let linkItem of linkItems" [nzValue]="linkItem.id" [nzLabel]="linkItem.label"></nz-option>
                </nz-select>
                <span class="text-danger" *ngIf="notificationForm.get('deepLinkId')?.errors?.['required'] && notificationForm.get('deepLinkId')?.touched">
                  Please select an item to link.
                </span>
                <span
                  class="deep-link-hint"
                  *ngIf="notificationForm.get('deepLinkType')?.value !== 0"
                >
                  This notification will be sent only to users who have access to the selected item.
                </span>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div class="d-flex justify-content-end">
          <button type="button" nz-button nzType="default" class="m-r-10" (click)="closeNotificationForm()">
            Cancel
          </button>
          <button type="button" nz-button nzType="default" class="m-r-10" (click)="resetNotificationForm()">
            Reset
          </button>
          <button type="button" nz-button nzType="primary" (click)="submitNotification()">
            {{ updateMode ? 'Update Notification' : 'Add Notification' }}
          </button>
        </div>
          </form>
        </nz-tab>

        <nz-tab nzTitle="Announcement" [nzDisabled]="updateMode && !isAnnouncementChannel">
          <form nz-form nzLayout="vertical" [formGroup]="announcementForm" class="notification-tab-form">
            <div nz-row nzGutter="16">
              <div nz-col nzSpan="24">
                <nz-form-item>
                  <nz-form-label nzRequired>Title</nz-form-label>
                  <nz-form-control>
                    <input nz-input formControlName="title" placeholder="Announcement title" />
                    <span
                      class="text-danger"
                      *ngIf="announcementForm.get('title')?.errors?.['required'] && announcementForm.get('title')?.touched"
                    >
                      This field is required.
                    </span>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div nz-row nzGutter="16">
              <div nz-col nzSpan="24">
                <nz-form-item>
                  <nz-form-label nzRequired>Announcement</nz-form-label>
                  <nz-form-control>
                    <quill-editor
                      formControlName="description"
                      [modules]="announcementModules"
                      class="editor-container"
                      [styles]="{ 'min-height': '160px' }"
                    ></quill-editor>
                    <span
                      class="text-danger"
                      *ngIf="announcementForm.get('description')?.errors?.['required'] && announcementForm.get('description')?.touched"
                    >
                      This field is required.
                    </span>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>

            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <span class="m-r-10" style="font-weight: 500;">Active</span>
                <nz-switch [(ngModel)]="announcementActive" [ngModelOptions]="{ standalone: true }"></nz-switch>
              </div>
              <div>
                <button type="button" nz-button nzType="default" class="m-r-10" (click)="closeNotificationForm()">
                  Cancel
                </button>
                <button type="button" nz-button nzType="default" class="m-r-10" (click)="resetNotificationForm()">
                  Reset
                </button>
                <button type="button" nz-button nzType="primary" (click)="submitNotification()">
                  {{ updateMode ? 'Update Announcement' : 'Save Announcement' }}
                </button>
              </div>
            </div>
          </form>
        </nz-tab>
      </nz-tabset>
    </nz-spin>
  </nz-card>

  <nz-card class="notification-list-card" *ngIf="!notificationFormVisible">
    <div class="notification-list-header">
      <h4 class="m-b-0">Notifications</h4>
      <div class="notification-list-toolbar">
        <span class="text-muted notification-total">{{ notifications.length }} total</span>
        <nz-select
          class="notification-status-filter"
          [ngModel]="selectedStatusFilter"
          (ngModelChange)="onStatusFilterChange($event)"
          nzPlaceHolder="Filter"
        >
          <nz-option nzValue="all" nzLabel="All"></nz-option>
          <nz-option nzValue="announcement" nzLabel="Announcement"></nz-option>
          <nz-option nzValue="push" nzLabel="Push"></nz-option>
          <nz-option nzValue="1" nzLabel="Push · Instant"></nz-option>
          <nz-option nzValue="2" nzLabel="Push · Scheduled"></nz-option>
        </nz-select>
        <!-- Run scheduled push — hidden until we expose it again
        <button
          nz-button
          nzType="default"
          [nzLoading]="isProcessingScheduled"
          (click)="runScheduledPushProcessor()"
        >
          Run scheduled push
        </button>
        -->
        <button nz-button nzType="primary" (click)="openAddForm()">
          Add
        </button>
      </div>
    </div>
    <nz-table
      class="notification-table"
      [nzData]="notifications"
      [nzPageSize]="10"
      [nzFrontPagination]="true"
      [nzLoading]="showLoad"
    >
      <thead>
        <tr>
          <th nzWidth="48px" nzAlign="center"></th>
          <th nzWidth="22%">Title</th>
          <th nzWidth="24%">Body</th>
          <th nzWidth="10%" nzAlign="center">Type</th>
          <th nzWidth="12%">Scheduled At <span class="tz-hint">(PT)</span></th>
          <th nzWidth="12%">Created</th>
          <th nzWidth="14%" nzAlign="center">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of notifications">
          <td nzAlign="center">
            <img
              class="channel-icon"
              [src]="
                item.channel === 2
                  ? 'assets/images/logo/announcement.png'
                  : 'assets/images/logo/pushIcon.png'
              "
              [alt]="getChannelLabel(item.channel)"
              nz-tooltip
              [nzTooltipTitle]="getChannelLabel(item.channel)"
            />
          </td>
          <td>
            <span class="cell-ellipsis" [title]="item.title">{{ item.title }}</span>
          </td>
          <td>
            <span class="cell-ellipsis" [title]="getBodyPreview(item)">{{ getBodyPreview(item) }}</span>
          </td>
          <td nzAlign="center" class="type-cell">
            <span>{{ getDeliveryTypeLabel(item) }}</span>
          </td>
          <td>
            <span
              class="cell-ellipsis"
              [title]="
                item.channel === 2
                  ? '—'
                  : item.scheduled_at
                    ? (item.scheduled_at | date: 'MM/dd/yyyy hh:mm a')
                    : 'Instant'
              "
            >
              {{
                item.channel === 2
                  ? '—'
                  : item.scheduled_at
                    ? (item.scheduled_at | date: 'MM/dd/yyyy hh:mm a')
                    : 'Instant'
              }}
            </span>
          </td>
          <td>
            <span class="cell-ellipsis" [title]="item.created | date: 'MM/dd/yyyy hh:mm a'">
              {{ item.created | date: 'MM/dd/yyyy hh:mm a' }}
            </span>
          </td>
          <td nzAlign="center">
            <div class="notification-actions">
              <a
                *ngIf="canEditNotification(item)"
                nz-button
                nzType="default"
                nzShape="circle"
                nzSize="small"
                nz-tooltip
                nzTooltipTitle="Edit"
                (click)="editNotification(item)"
              >
                <i nz-icon nzType="edit" nzTheme="outline"></i>
              </a>
              <!-- Clone hidden for now
              <button
                *ngIf="item.channel === 1"
                nz-button
                nzType="default"
                nzShape="circle"
                nzSize="small"
                nz-tooltip
                nzTooltipTitle="Clone"
                (click)="cloneNotification(item)"
              >
                <i nz-icon nzType="copy" nzTheme="outline"></i>
              </button>
              -->
              <button
                nz-button
                nzType="default"
                nzShape="circle"
                nzSize="small"
                nz-tooltip
                nzTooltipTitle="Delete"
                nz-popconfirm
                nzPopconfirmTitle="Are you sure you want to delete this item?"
                (nzOnConfirm)="deleteNotification(item.notification_id)"
              >
                <i nz-icon nzType="delete" nzTheme="outline"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </nz-card>
</div>
